export default __webpack_public_path__ + "static/media/owner.4efd5eb4.jpeg";